//Importing the images 
import meme from "../src/img/meme.png";
import routing from "../src/img/routing.png";
import todo from "../src/img/todo.png";
import weather from "../src/img/weather.png";
import tinDog from "../src/img/tindog.png";
import groove from "../src/img/groove.png"
import matrialui from "../src/img/matrialui.png"
import proximoerp from "../src/img/proximoerp.png"

export const products = [
    {
      id: 1,
      img:  meme,
      link: "https://pankajsharma-4x.github.io/meme-generator-app/",
    },
    {
      id: 2,
      img: routing,
      link: "https://pankajsharma-4x.github.io/react-routing/",
    },
    {
      id: 3,
      img: todo,
      link: "https://pankajsharma-4x.github.io/ToDo-App/",
    },
    {
      id: 4,
      img:   weather,
      link: "https://pankajsharma-4x.github.io/weather-update-app/",
    },
    {
      id: 5,
      img: tinDog,
      link: "https://pankajsharma-4x.github.io/TinDog/",
    },
    {
      id: 6,
      img: groove,
      link: "https://pankajsharma-4x.github.io/GROOV/",
    },
    {
      id: 7,
      img: matrialui,
      link: "https://matrialui.netlify.app",
    },
    {
      id: 8,
      img: proximoerp,
      link: "https://proximoerp.netlify.app",
    },
    
  ];